/*
Ashraf 11/19/2022 2700912712 Implemented Copy Functionality
Dilip 12/05/2022  2700912712 Removed unecesarry console.log statements
akhila 12/20/2022 2700912712 fixed underScore issue
Lalitha 12/23/2022 2700912712 Added reusable Validation in code
akhila 12/27/2022 2700912712 fixed description issue
Gireesh 12/27/2022 2700912712 fixed placeholder issue
dilip 12/27/2022 2700912712 fixed description validation issue
sai krisha 30/12/2022 2700912712 add code description values
Akhila 01/19/2023 2700912712 bug fixed Last letter of the data code is downloaded in small case
manikanta 02/01/2023 2700912712 fixed Description
sohel 03/06/2023 2700912712 Added validation message for existing value
Guru Prasad 04/11/2023 2700912712 Fixed alignments
Akhila 06/07/2023 2700912712 added breadcrum code and description
Gireesh 12/11/2023 2700912712 Added Data Calculation Code validation and description
Gireesh 12/11/2023 2700912712 removed uppercase for Data Calculation Code validation in payload
*/
import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from './../../../../../components/PageLoader/index';
import {
  fetchAllCodeAndDisplayName,
  postCopyFormula,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import BreadCrums from '../../../../../util/BreadCrum';
const CopyFormula = ({oldFilterCode, codeAndDescription}) => {
  useEffect(() => {
    dispatch(fetchAllCodeAndDisplayName());
  }, []);
  
  const {reusableInputStyles} = useContext(ThemeContext);

  const {
    iscopyLoading,
    allCodeAndDisplayName,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
    name: '',
  };

  const checkCodeExist = (value) => {
    if (allCodeAndDisplayName && allCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allCodeAndDisplayName.filter((i) => {
        if (
          i?.code?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (allCodeAndDisplayName && allCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allCodeAndDisplayName.filter((i) => {
        if (
          i?.code?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    code: Yup.string()
      .required('Data Calculation Name is required')
      .test('code', 'Data Calculation Name already exist', (value) => {
        return !checkCodeExist(value);
      })
      .test('code', 'Data Calculation Name has already been used in the past', (value) => {
        return !checkCodeAlreadyExist(value);
      }),
    // name:Yup.string()
    //   .required("Filter Name is required")
    //   .test("displayName", "Filter Name already exist", (value) => !checkDisplayNameExist(value)),
    description: Yup.string()
      .test('description', 'Data Calculation Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Data Calculation Description is required')
  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        code: values?.code ? values?.code : '',
        description: values?.description ? values?.description : '',
        displayName: values?.name ? values?.name : '',
        oldFormulaRuleGroupCode: oldFilterCode,
        formulaRuleGroupId:codeAndDescription?.groupId,
      };
      dispatch(postCopyFormula(data));
    }
  };

  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Name'}
                    code={codeAndDescription?.code}
                    description={'Description'}
                    descriptionValue={codeAndDescription?.description}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields mt-2">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Data Calculation Name"
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              label="Data Calculation Name"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 25}}
                              required
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('code', e.target.value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>
                          {/* <Grid item xs={6} className="form-group">
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Formula Name"
                              margin="dense"
                              name="name"
                              value={values.name}
                              variant="outlined"
                              label="Formula Name"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("name", e.target.value);
                              }}
                              touched={touched.name}
                              required
                              error={Boolean(errors.name && touched.name)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.name && errors.name}
                            </FormHelperText>
                          </Grid> */}
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Data Calculation Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Data Calculation Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 100}}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="d-flex justify-content-center new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {iscopyLoading && <PageLoader />}
    </>
  );
};

export default CopyFormula;
